import { Typography } from 'core/Typography';
import Image from 'next/image';
import React from 'react';
import SectionWrapper from 'shared/SectionWrapper';

function Card({ title, image }: { title?: string; image?: string }) {
    return (
        // eslint-disable-next-line max-len
        <div className="p-[24px] xl-desktop:p-[40px] gap-[24px] flex justify-between flex-col bg-bg-grey rounded-[24px] min-h-[180px] mobile:min-h-[298px]">
            {image && (
                <div className={'size-[48px] min-w-[48px] min-h-[48px] relative'}>
                    <Image fill src={`${image}`} alt={title || ''} objectFit={'contain'} />
                </div>
            )}

            <Typography>{title}</Typography>
        </div>
    );
}

function Problem() {
    return (
        <SectionWrapper>
            <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                <Typography variant="h2">Проблема</Typography>
                <div className="flex flex-col gap-[24px]">
                    <Typography className="lg-tablet:max-w-8/12">
                        Идея TalentMind родилась из собственного опыта. Как и многие компании,
                        мы сталкивались с ситуацией, когда новый сотрудник изначально нам подходил
                        по техническим навыкам, но через несколько месяцев становилось очевидно:
                        человек не вписался в команду, не справляется с задачами или теряет
                        мотивацию.
                    </Typography>

                    <Typography variant={'h3'}>Ключевые бизнес-задачи продукта:</Typography>

                    <div
                        className={
                            'grid grid-cols-1 mobile:grid-cols-2 desktop:grid-cols-4 gap-[24px] xl-desktop:gap-x-[40px]'
                        }
                    >
                        <Card
                            title={'Дополнить экспертизу рекрутеров данными'}
                            image={'/images/pic/talent-mind/problem-icon-1.svg'}
                        />
                        <Card
                            title={'Снизить процент ошибочного найма'}
                            image={'/images/pic/talent-mind/problem-icon-2.svg'}
                        />
                        <Card
                            image={'/images/pic/talent-mind/problem-icon-3.svg'}
                            title={'Стандартизировать процесс оценки'}
                        />
                        <Card
                            image={'/images/pic/talent-mind/problem-icon-4.svg'}
                            title={'Сделать HR-аналитику доступной'}
                        />
                    </div>
                </div>
            </div>
        </SectionWrapper>
    );
}

export default Problem;
